<flx-modal>
  <div
    class="flx-modal-title"
    flxModalHeaderTitle
  >
    {{ type }} in progress
  </div>

  <flx-spinner
    [radius]="90"
    size="small"
    visualType="custom"
  ></flx-spinner>
</flx-modal>
